import { Component, Input, OnInit, Output, EventEmitter } from "@angular/core";
import { Campaign } from "src/app/interfaces/campaign-interface";
import { AppLinksService } from "src/app/services/applinks/app-links.service";
import { BonusService } from "src/app/services/bonus/bonus.service";

@Component({
  selector: "app-promotion-detail",
  templateUrl: "./promotion-detail.component.html",
  styleUrls: ["./promotion-detail.component.scss"],
})
export class PromotionDetailPage implements OnInit {
  @Input() promoDetail: Campaign;
  @Output() closeDetail: EventEmitter<any> = new EventEmitter();

  constructor(private bonusService: BonusService, public appLinks: AppLinksService) {
    // this.promoDetail =  {} ; //this.navParams?.data?.data?.promo;
    // this.promoDetail =  this.navParams?.data?.data?.promo;
  }

  ngOnInit() {
    this.bonusService.setPromoDetailInfo(null);
    if (!this.promoDetail) {
      this.promoDetail = {
        id: 0,
        campaign_type: "",
        campaign_code: "",
        campaign_category: "",
        description: "",
        bg_path: "",
        show_banner_flag: false,
        banner_image_large: "",
        banner_image_medium: "",
        banner_image_small: "string",
        banner_action: "string",
        banner_url: "",
        tagline: "string",
        app: "string",
        include_visitors: false,
      };
    }
  }

  public openExternalLinks(url, title): any{
    return this.appLinks.openPopover(url, title)
  }

  closeDialog() {
    this.closeDetail.emit();
  }
}
